import { useScriptState } from './useScriptState'

import {
  getCurrentEventIndex,
  parseStepKey,
} from '@/components/Event/NewScript/utils/stepKey'
import { AttendeeRole, ScriptStep } from '@/constants'
import { EventScriptDataObject, ScriptAttendee, ScriptData } from '@/types'

type HookResult = ReturnType<typeof useScriptState> & {
  currentStep: ScriptStep
  currentEventIndex: number | undefined
  currentEvent: EventScriptDataObject | undefined
  witness: ScriptAttendee | undefined
}

export const useScriptFlowState = (): HookResult => {
  const { state, ...rest } = useScriptState()
  const scriptData = state as ScriptData
  const { step: currentStep } = parseStepKey(scriptData.current_step)
  const currentEventIndex = getCurrentEventIndex(
    scriptData.current_step,
    scriptData.events.length,
  )
  const currentEvent =
    currentEventIndex !== undefined
      ? scriptData.events[currentEventIndex]
      : undefined
  const witness = currentEvent?.attendees.find(
    attendee => attendee.role === AttendeeRole.WITNESS,
  )

  return {
    ...rest,
    state: scriptData,
    currentStep,
    currentEventIndex,
    currentEvent,
    witness,
  }
}
